import { useState } from 'react';
import { accessoEsternoPublic } from '../utils/api';
import AccesoEsternoPortale from './AccesoEsternoPortale';

const CARD_SHADOW = '0 6px 18px rgba(35,38,47,0.08)';

var container = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'var(--chip)',
  padding: 20,
  fontFamily: 'Inter, Arial, sans-serif',
};

var card = {
  width: '100%',
  maxWidth: 480,
  background: 'var(--ds-bg)',
  borderRadius: 'var(--radius-card)',
  boxShadow: CARD_SHADOW,
  overflow: 'hidden',
};

var logoBar = {
  background: 'var(--brand)',
  padding: '28px 32px',
  textAlign: 'center',
};

var body = { padding: '32px 32px 28px' };

var inp = {
  width: '100%', padding: '11px 14px', borderRadius: 'var(--radius-base)',
  border: '0.5px solid var(--ds-border)', fontSize: 14, outline: 'none',
  boxSizing: 'border-box', fontFamily: 'inherit', color: 'var(--ds-text)',
};

var lbl = {
  display: 'block', fontSize: 12, fontWeight: 500,
  color: 'var(--ds-muted)', marginBottom: 6,
};

var btnPrimary = {
  width: '100%', padding: '12px 20px', borderRadius: 'var(--radius-base)',
  border: 'none',
  background: 'var(--brand)',
  color: '#fff', fontSize: 14, fontWeight: 500, cursor: 'pointer',
  minHeight: 44,
};

function Logo() {
  return (
    <div>
      <h1 style={{ margin: 0, color: '#fff', fontSize: 24, fontWeight: 500, letterSpacing: -0.5, fontFamily: 'var(--font-display)' }}>mAIstro</h1>
      <p style={{ margin: '4px 0 0', color: 'rgba(255,255,255,0.85)', fontSize: 12, fontWeight: 400 }}>Portale accesso dedicato</p>
    </div>
  );
}

export default function AccesoEsterno() {
  var [stato, setStato] = useState('login'); // login, cambio_password, portale
  var [email, setEmail] = useState('');
  var [password, setPassword] = useState('');
  var [loading, setLoading] = useState(false);
  var [errore, setErrore] = useState('');
  var [token, setToken] = useState(null);
  var [utente, setUtente] = useState(null);

  // Cambio password
  var [pwAttuale, setPwAttuale] = useState('');
  var [pwNuova, setPwNuova] = useState('');
  var [pwConferma, setPwConferma] = useState('');

  var handleLogin = function() {
    if (!email || !password) return;
    setLoading(true);
    setErrore('');
    accessoEsternoPublic.login(email, password)
      .then(function(res) {
        var d = res.data;
        setToken(d.token);
        setUtente(d);
        if (d.primo_accesso) {
          setPwAttuale(password);
          setStato('cambio_password');
        } else {
          setStato('portale');
        }
      })
      .catch(function(err) {
        setErrore(err.response?.data?.detail || 'Errore di accesso');
      })
      .finally(function() { setLoading(false); });
  };

  var handleCambioPassword = function() {
    if (!pwNuova || pwNuova.length < 8) {
      setErrore('La password deve avere almeno 8 caratteri.');
      return;
    }
    if (pwNuova !== pwConferma) {
      setErrore('Le password non coincidono.');
      return;
    }
    setLoading(true);
    setErrore('');
    accessoEsternoPublic.cambiaPassword(token, pwAttuale, pwNuova)
      .then(function() {
        setStato('portale');
      })
      .catch(function(err) {
        setErrore(err.response?.data?.detail || 'Errore nel cambio password');
      })
      .finally(function() { setLoading(false); });
  };

  var handleKeyDown = function(handler) {
    return function(e) {
      if (e.key === 'Enter') handler();
    };
  };

  // PORTALE POST-LOGIN
  if (stato === 'portale' && token) {
    return <AccesoEsternoPortale token={token} utente={utente} onLogout={function() { setStato('login'); setToken(null); setUtente(null); setEmail(''); setPassword(''); }} />;
  }

  // CAMBIO PASSWORD OBBLIGATORIO
  if (stato === 'cambio_password') {
    return (
      <div style={container}>
        <div style={card}>
          <div style={logoBar}><Logo /></div>
          <div style={body}>
            <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 500, color: 'var(--ink)', fontFamily: 'var(--font-display)' }}>Cambio password obbligatorio</h2>
            <p style={{ fontSize: 13, color: 'var(--ds-muted)', margin: '0 0 20px', fontWeight: 400 }}>
              Al primo accesso devi scegliere una nuova password.
            </p>

            <div style={{ marginBottom: 14 }}>
              <label style={lbl}>Nuova password</label>
              <input
                type="password" style={inp} value={pwNuova}
                onChange={function(e) { setPwNuova(e.target.value); }}
                placeholder="Minimo 8 caratteri"
              />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={lbl}>Conferma password</label>
              <input
                type="password" style={inp} value={pwConferma}
                onChange={function(e) { setPwConferma(e.target.value); }}
                onKeyDown={handleKeyDown(handleCambioPassword)}
                placeholder="Ripeti la password"
              />
            </div>

            {errore && <p style={{ color: 'var(--ds-danger)', fontSize: 12, margin: '0 0 14px', fontWeight: 400 }}>{errore}</p>}

            <button onClick={handleCambioPassword} disabled={loading} style={Object.assign({}, btnPrimary, { opacity: loading ? 0.6 : 1 })}>
              {loading ? 'Salvataggio...' : 'Salva nuova password'}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // LOGIN
  return (
    <div style={container}>
      <div style={card}>
        <div style={logoBar}><Logo /></div>
        <div style={body}>
          <h2 style={{ margin: '0 0 20px', fontSize: 18, fontWeight: 500, color: 'var(--ink)', fontFamily: 'var(--font-display)' }}>Accedi</h2>

          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>Email</label>
            <input
              type="email" style={inp} value={email}
              onChange={function(e) { setEmail(e.target.value); }}
              placeholder="email@esempio.it"
              autoFocus
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={lbl}>Password</label>
            <input
              type="password" style={inp} value={password}
              onChange={function(e) { setPassword(e.target.value); }}
              onKeyDown={handleKeyDown(handleLogin)}
              placeholder="La tua password"
            />
          </div>

          {errore && <p style={{ color: 'var(--ds-danger)', fontSize: 12, margin: '0 0 14px', fontWeight: 400 }}>{errore}</p>}

          <button onClick={handleLogin} disabled={loading} style={Object.assign({}, btnPrimary, { opacity: loading ? 0.6 : 1 })}>
            {loading ? 'Accesso...' : 'Accedi'}
          </button>
        </div>
      </div>
    </div>
  );
}
